import React from "react";

const Sponsors = () => {
  return (
    <div className="content">
      <h1 className="title">Förderer</h1>
      <ul>
        <li>Bezirksvertretung Nippes</li>
        <li>Netzwerk e.V.</li>
        <li>Für Nippes e.V. Bürgerverein für den Stadtteil Nippes</li>
        <li>Amt für Kinder, Jugend und Familie - Bezirksjugendamt Nippes</li>
        <li>Bezirksvertretung Mülheim</li>
        <li>Christliche Sozialhilfe Köln e.V.</li>
        <li>Sozialraumkoordination Mülheim-Nord/Keupstr.</li>
      </ul>
    </div>
  );
};

export default Sponsors;



/** WEBPACK FOOTER **
 ** ./src/components/Sponsors.jsx
 **/